import React from "react";
import { Box, Grid, Grow, useScrollTrigger } from "@material-ui/core";

import { Section } from "../components";
import "../styles/index.scss";
import { en } from "../content";

function Education({ scrollThreshold, isMobile }) {
  const content = en.education;
  const scrollTrigger = useScrollTrigger({
    threshold: scrollThreshold,
    disableHysteresis: true,
  });

  return (
    <Box
      className={`education ${
        isMobile ? "educationMobile" : "educationDesktop"
      }`}
      top={0}
      position={isMobile ? "relative" : "sticky"}
    >
      <Section>
        <Box>
          <Box className="banner" mb={4}>
            {content.title}
          </Box>
          <Grow in={scrollTrigger} timeout={2400}>
            <Box className="subsection">
              <Grid
                container
                display="flex"
                width="100%"
                alignItems="flex-end"
                justifyContent="space-between"
                className="titleBox"
              >
                <Grid item xs={12} md={6}>
                  <Box
                    item
                    className="school"
                    display="flex"
                    width="100%"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    {content.graduate.school}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    item
                    className="time"
                    display="flex"
                    width="100%"
                    alignItems="center"
                    justifyContent={isMobile ? "flex-start" : "flex-end"}
                  >
                    {content.graduate.time}
                  </Box>
                </Grid>
              </Grid>

              <Box mt={1} fontStyle="italic">
                {isMobile ? (
                  <Box>
                    <Box>{content.graduate.major.split(":")[0]},</Box>
                    <Box>{content.graduate.major.split(":")[1].trim()}</Box>
                  </Box>
                ) : (
                  <Box>{content.graduate.major}</Box>
                )}
              </Box>
              <Box>GPA: {content.graduate.gpa}/4.0</Box>
            </Box>
          </Grow>
          <Grow in={scrollTrigger} timeout={4800}>
            <Box className="subsection" mt={4}>
              <Grid
                container
                display="flex"
                width="100%"
                alignItems="flex-end"
                justifyContent="space-between"
                className="titleBox"
              >
                <Grid item xs={12} md={6}>
                  <Box
                    item
                    className="school"
                    display="flex"
                    width="100%"
                    alignItems="center"
                    justifyContent="flex-start"
                  >
                    {content.undergraduate.school}
                  </Box>
                </Grid>
                <Grid item xs={12} md={6}>
                  <Box
                    item
                    className="time"
                    display="flex"
                    width="100%"
                    alignItems="center"
                    justifyContent={isMobile ? "flex-start" : "flex-end"}
                  >
                    {content.undergraduate.time}
                  </Box>
                </Grid>
              </Grid>

              <Box mt={1} fontStyle="italic">
                {isMobile ? (
                  <Box>
                    <Box>{content.undergraduate.major.split(":")[0]},</Box>
                    <Box>
                      {content.undergraduate.major.split(":")[1].trim()}
                    </Box>
                  </Box>
                ) : (
                  <Box>{content.graduate.major}</Box>
                )}
              </Box>
              <Box>GPA: {content.undergraduate.gpa}/4.0</Box>
            </Box>
          </Grow>
        </Box>
      </Section>
    </Box>
  );
}

export default Education;
